export const SET_MEDIA_SELECTED_DATA = "SET_MEDIA_SELECTED_DATA";
export const ADD_TO_DATA_SELECTED_MEDIA = "ADD_TO_DATA_SELECTED_MEDIA";
export const INDEX_DATA_SELECTED_MEDIA = "INDEX_DATA_SELECTED_MEDIA";
export const DELETE_DATA_SELECTED_MEDIA = "DELETE_DATA_SELECTED_MEDIA";